module.exports = __webpack_public_path__ + "img/M02.2c093aa4.png";